import {IconButton, Menu, MenuItem} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {setCampaignView} from '../../store/selectedView/campaignView/campaignViewIndex'
import {constituentIdList} from '../../store/prospectSegment/savedProspectsList/saveProspectsListSlice'
import {getSavedProspectsPageNumber} from '../../store/pagination/pageNumberSlice'
import {
  getAllProspectsData,
  getAllSavedProspectsData,
  setSelectedOppurtunity
} from '../../store/prospectSegment/allProspectsData/allProspectsDataSlice'
import {setCampaignAction} from '../../store/selectedView/campaignView/campaignActionSlice'
import {setAllConstituentsFilters} from '../../store/prospectSegment/openSavedProspect/openSavedProspectSlice'
import PropTypes from 'prop-types'
import {setAddToSavedProspects} from '../../store/prospectSegment/addToSavedProspects/addToSavedProspectsSlice'

const ActionMenu = ({constituentId, listName, actionMenuList}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const openVerticalMenu = Boolean(anchorEl)
  const dispatch = useDispatch()
  const getListName = useSelector((state) => state.campaignAction)
  const {name} = getListName

  const selectedItemCurrentPageNumber = useSelector((state) => state.currentPageNumber.savedProspectsValue)
  const askGivePrismFilters = useSelector((state) => state.askGivePrism.filters)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
    event.stopPropagation()
  }
  const handleClose = (event) => {
    setAnchorEl(null)
    event.stopPropagation()
  }

  const handleMenuClick = (event, option) => {
    event.stopPropagation()
    if (option === 'openList') {
      dispatch(setCampaignView('openProspectList'))
      dispatch(setCampaignAction({actionName: 'openSavedList', name: listName}))
      dispatch(
        setAllConstituentsFilters({
          searchTerm: ''
        })
      )
      dispatch(setSelectedOppurtunity([]))
      Object.keys(askGivePrismFilters).length > 0 && dispatch(getAllProspectsData([]))
    }
    if (option === 'deleteList') {
      setAnchorEl(null)
      dispatch(setCampaignAction({actionName: 'deleteSavedList', name: listName}))
    }

    if (option === 'addToSavedList') {
      dispatch(setAddToSavedProspects([]))
      dispatch(constituentIdList([constituentId]))
      dispatch(setCampaignView('addToSavedList'))
      dispatch(setCampaignAction('addToSavedList'))
      if (selectedItemCurrentPageNumber !== 1) {
        dispatch(getAllSavedProspectsData([]))
        dispatch(getSavedProspectsPageNumber(1))
      }
      dispatch(
        setAllConstituentsFilters({
          searchTerm: ''
        })
      )
    }
    if (option === 'removeFromList') {
      setAnchorEl(null)
      dispatch(constituentIdList([constituentId]))
      dispatch(setCampaignAction({actionName: 'removeFromList', name}))
    }
  }

  return (
    <>
      <IconButton size="small" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu id="menu-item" anchorEl={anchorEl} open={openVerticalMenu} onClose={handleClose}>
        {actionMenuList.map((option) => (
          <MenuItem key={option.key} onClick={(event) => handleMenuClick(event, option.key)}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

ActionMenu.propTypes = {
  constituentId: PropTypes.string,
  listName: PropTypes.string,
  actionMenuList: PropTypes.array
}

export default ActionMenu
